<template>
    <div>
        <v-container>
            <div class="text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
                Preguntas
            </div>

            <v-expansion-panels v-model="activePanels">
                <v-expansion-panel style="background-color: #F5F5F5" @click.prevent="toogleFilters">
                    <v-expansion-panel-header>
                        <span class="header">Filtros</span>
                        <template v-slot:actions>
                            <v-btn icon @click.stop="toogleFilters">
                                <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-form :disabled="loading">
                            <v-row>
                                <v-col class="mb-n7" cols="6" sm="5" md="3" lg="3" xl="2">
                                    <DateFind label="Desde" v-model="filtros.FechaDesde"></DateFind>
                                </v-col>

                                <v-col class="mb-n7" cols="6" sm="5" md="3" lg="3" xl="2">
                                    <DateFind label="Hasta" v-model="filtros.FechaHasta"></DateFind>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            

            <v-btn v-if="esDepartamento"
            to="/pregunta-nueva"
            color="primary"
            class="mt-5 mb-3 mr-2">
            Nueva
            </v-btn>

            <v-data-table
                :headers="headers"
                :items="dataRows"
                :options.sync="options"
                :footer-props="{itemsPerPageOptions: [15, 30, 50, 100],disablePagination:loading, disableItemsPerPage: loading}"
                :server-items-length="totalDataRows"
                :loading="loading"
                @click:row="onClickRowEditar"
                style="overflow: scroll"
                mobile-breakpoint="0"
                class="elevation-1"
                dense
                >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.FechaCreacion="{ item }">
                    {{ formatDate(item.FechaCreacion) }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.Enviado="{ item }">
                    <v-simple-checkbox v-model="item.Enviado" disabled></v-simple-checkbox>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>

import axios from "axios";
import funcs from "../../funcs";
import { mapState } from "vuex";
import DateFind from "../../components/DateFind.vue";

export default ({
    components: {
        DateFind
    },
    computed: {
        ...mapState(['empId', 'dirId', 'perId', 'perIdAux', 'esTienda', 'esDepartamento', 'urlRaiz']),
        headers: function() {
            if (this.esDepartamento) { return this.headersBase.concat(this.headersAdmin); }
            if (this.esTienda) { return this.headersBase.concat(this.headersTienda); }
            return [];
        },
    },
    data () {
        return {
            loading: true,
            activePanels: 0,
            totalDataRows: 0,
            dataRows: [],
            options: {itemsPerPage: 30},
            headersBase: [
                { text: 'Identificador', width: 30, sortable: false, value: 'PreguntaId' },
                { text: 'Nombre Formulario', width:300, sortable: false, value: 'Descripcion' },
                { text: 'Fecha', width: 50, sortable: false, value: 'FechaCreacion' }
            ],
            headersAdmin: [],
            headersTienda: [
                { text: 'Enviado', width: 70, sortable: false, value: 'Enviado' }
            ],
            dtOptionsLoaded: false,
            filtros: {
                FechaDesde: null,
                FechaHasta: null
            }
        }
    },
    watch: {
      options: {
        handler () {
          if(!this.dtOptionsLoaded){
            this.dtOptionsLoaded = true;
            return;
          }
          this.loadData();
        },
        deep: true
      },
      filtros: {
        handler () {
          this.loadData();
        },
        deep: true
      }
    },
    mounted() {
      if (!this.esDepartamento && !this.esTienda) { this.$router.push('/'); return; }
      this.loadData();
    },
    methods: {
      getDataFromApi() {
        this.loading = true;

        var NumRegsPag = this.options.itemsPerPage;
        var NumPag = this.options.page;

        return new Promise((resolve) => {
          const controllerParameters = {
            NumRegsPag: NumRegsPag,
            NumPag: NumPag,
            EmpId: this.empId,
            DirId: this.esTienda ? this.dirId : null,
            FechaDesde: this.filtros.FechaDesde,
            FechaHasta: this.filtros.FechaHasta
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/preguntas/list", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const items = result.data.EntsList;
            const total = result.data.EntsTotCount;

            setTimeout(() => {
                this.loading = false
                resolve({
                  items,
                  total,
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert("Error al cargar las preguntas");
            }
          });
        })
      },
      loadData(){
        this.getDataFromApi()
        .then(data => {
          this.dataRows = data.items
          this.totalDataRows = data.total
        });
      },
      onClickRowEditar(item){
        if (this.esDepartamento) { 
            this.$router.push('/pregunta-editar/' + item.PreguntaId);
        }
        else if (this.esTienda) { 
            this.$router.push('/pregunta-respuesta/' + item.PreguntaId);
        }
      },
      toogleFilters() {
        this.activePanels = this.activePanels == null ? 0 : undefined;
      },
      formatDate(value)
      {
          return funcs.formatDate(value);
      }
    } 
})
</script>
